import React, { FC, ReactNode } from 'react';
import './ExportButton.css';
import { FaFileExcel } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface ExportButtonProps {
	onClick: () => void;
	isLoading?: boolean;
	count?: number | string,
	icon?: ReactNode,
	tooltip? : string
}

const ExportButton: FC<ExportButtonProps> = ({ onClick, isLoading, count, icon = <FaFileExcel />, tooltip = "Bouton d'export" }) => (
	<ActionButton
		classNames="ExportButton"
		icon={icon}
		label={'Exporter' + (count ? ` ${count}` : '')}
		onClick={onClick}
		isLoading={isLoading}
		tooltip={tooltip}
		showLabel
	/>
);

export default ExportButton;
